import EditBussinessBooking from "../pages/BussinessAgent/editBussinessBooking";
import ReportsPage from "../pages/BussinessAgent/CompanyAgentCommonReports";
import PatientTransfer from "../services/PatientTransfer";

const base = '/';

let apiBase = "https://i5y2sl7e13.execute-api.ap-south-1.amazonaws.com/api/";

export const paths = {
    home: base,
    accounts: {
        home: base + 'accounts',
        login: base + 'accounts/login',
        socialLogin: base + 'accounts/social-login',
        forgetPassword: base + 'accounts/forget-password',
        changePassword: base + 'accounts/change-password',
        driverRegister: base + 'accounts/driver-register',
        agentRegister: base + 'accounts/agent-register',
        partnerRegister: base + 'accounts/partner-register',
        driverCarrierRegister: base + 'accounts/driver-carrier-registration',

    },


    driver: {
        home: base + 'driver', 
        driveVehicle: base + 'driver/drive-vehicle',
        dashboard: base + 'driver/dashboard',
        upcomingRides: base + 'driver/upcoming-rides',
        invoiceHistory: base + 'driver/invoice-history',
        taxValues: base + 'driver/tax-values',
        driverEditProfile: base + 'driver/edit-profile',
        driverTermsCondition: base + 'driver/terms-conditions',
        openBooking: base + 'driver/open-booking',
        rideHistory: base + 'driver/ride-history',
         rideReport: base + 'driver/ride-report',
    },


    businessAgent: {
        home: base + 'businessAgent',
        dashboard: base + 'businessAgent/dashboard',
        editBussinessBooking: base + 'businessAgent/editBussinessBooking',
        editProfile: base + 'businessAgent/edit-profile',
        BussinessBooking: base + 'businessAgent/BussinessBooking',
        AgentBankInvoiceHistory: base + 'businessAgent/AgentBankInvoiceHistory',
        AgentCommissionInvoiceHistory: base + 'businessAgent/AgentCommissionInvoiceHistory',
        ReportsPage: base + 'businessAgent/ReportsPage',
        changePassword: base + 'businessAgent/change-password',
        termsAndCondition: base + 'businessAgent/terms-and-conditons',
    },


    admin: {
        home: base + 'admin',
        dashboard: base + 'admin/dashboard',
        partnerList: base + 'admin/partnerlist',
        partnerSetup: base + 'admin/partnersetup',
        userManager: base + 'admin/usermanager',
        addnewVehicle: base + 'admin/addnewvehicle',
        // driverRegister: base + 'driver/driver-register',
        adminbooking: base + 'admin/adminbooking',
        adminbookingId: base + 'admin/adminbooking-id',
        
    },

    company: {
        home: base + 'company',
        dashboard: base + 'company/dashboard',
        myStaff: base + 'company/my-staff',
        editProfile: base + 'company/edit-profile',
        editBussinessBooking: base + 'company/editBussinessBooking',
        companyRegisterStaff: base + 'company/company-register-staff',
        EditStaff: base + 'company/EditStaff',
        CompanyBankInvoiceHistory: base + 'company/CompanyBankInvoiceHistory',
        CompanyCommissionInvoiceHistory: base + 'company/CompanyCommissionInvoiceHistory',
        BussinessBooking: base + 'company/BussinessBooking',
        changePassword: base + 'company/change-password',
        termsAndCondition: base + 'company/terms-and-conditons',
cancellationPolicy: base + 'company/cancellationPolicy',
          companyReport: base + "company/company-report",
  customerReport: base + "company/customer-report",
  employeeReport: base + "company/employee-report",
    },

     driverCarrier: {
        home: base + 'driverCarrier', 
        dashboard: base + 'driverCarrier/dashboard', 
        openBooking: base + 'driverCarrier/openBooking',
        myBookings: base + 'driverCarrier/myBookings',
        assignDriverVehicle: base + 'driverCarrier/assignDriverVehicle', 
        upcomingBookings: base + 'driverCarrier/upcomingBookings',
        editProfile: base + 'driverCarrier/edit-profile',
        createBooking: base + 'driverCarrier/createBooking',
        editBooking: base + 'driverCarrier/editBooking',
        vehicles: base + 'driverCarrier/vehicles',
        driverForm: base + 'driverCarrier/driver/:mode/:id?', 
        driverList: base + 'driverCarrier/driverList',
        CarrierMyBookingsReports: base + 'driverCarrier/MyBookingsReport',
        driverReport: base + 'driverCarrier/DriverReport',
        vehicleReport: base + 'driverCarrier/VehicleReport',
        carrierRideHistory: base + 'driverCarrier/CarrierRideHistory',
        carrierInvoiceHistory: base + 'driverCarrier/CarrierInvoiceHistory',
        policy: base + 'driverCarrier/Policy',
        carrierTermsAndConditions: base + 'driverCarrier/CarrierTermsAndConditions',
        carrierCancellationPolicy: base + 'driverCarrier/CarrierCancellationPolicy',
    },


       user: {
       
    userHome: base + 'User',
           editProfile: base + 'User/edit-profile',
    dashboard: base + 'User/dashboard',
    rideReport: base + 'User/ride-report',
           bookingTermsAndCond: base + 'User/booking-terms-and-conditions',
    cancellationPolicy: base + 'User/cancellationPolicy',
    },
    vehicle: base + 'vehicle',
    contact: base + 'contact',
    summary: base + 'summary',
    done: base + 'done',
    adminbooking: base + 'adminbooking', 
    driveVehicle: base + 'drive-vehicle',

    bookingId: base + 'BookingId',
    termCondition: base + 'term-Condition',
    aboutUs: base + 'about-us',
    carrierTermsAndConditions2:base + 'CarrierTermsAndConditions',
    businessAgentTermsAndCondition2: base + 'agent-terms-and-conditons',
    companyTermsAndCondition2: base + 'company-terms-and-conditons',
    bookingTermsAndCond2: base + 'booking-terms-and-conditions',
    bookingTermsAndCond: base + 'booking-terms-and-conditions',
    cancellationPolicy: base + 'cancellationPolicy',
    bussinessAccount: base + 'bussiness-account',
    contactUs: base + 'contactUs',
    agentProfile: base + 'agentProfile',
    employeeBooking: base + 'employeeBooking',
    employeeUpcomingRides: base + 'employee-upcoming-rides',
    employeeRideHistory: base + 'employee-ride-history',
    employeeRideReport: base + 'employee-ride-report',
    employeeTermsAndCondition: base + 'employee-terms-and-conditions',
    agentTaxValues: base + 'agent-taxValue',
    privacyPolicy:base + 'privacy-policy',
    qans:base + 'q-a',
    AirportTemplate: base + 'airport/:slug',
    services:base+'services',
    cityToCityRides:base+'city-to-city-rides',
    vipService:base+'vip-service',
    businessTransfer:base+'Business-Transfer-service',
    privateCarService:base+'private-car-service',
    airportTransfer:base+'airport-transfer',
    baggageTransfer:base+'baggage-transfer',
    petTransfer: base+'pet-transfer',
    tourAndEventTransfer: base+'tour-and-event-transfer',
    patientTransfer: base+'patient-transfer',
}